export class ToFrontUnit {
    constructor(diagram, items, initialIndices) {
        this.diagram = diagram;
        this.indices = initialIndices;
        this.items = items;
        this.title = 'Rotate Unit';
    }
    undo() {
        this.diagram._toIndex(this.items, this.indices);
    }
    redo() {
        this.diagram.toFront(this.items, false);
    }
}
